import React, { useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import { getToken } from '../utils/auth';
// import { useDraftOrderActionModals } from '../hooks/useDraftOrderActionModals';
// import { useExpirationStatus } from '../hooks/useExpirationStatus';
import OrderHeader from './other/OrderHeader';
import LineItem from './other/LineItem';
import OrderStatusPills from './other/OrderStatusPills';
// import ModalShareQuote from '../components/modals/ModalShareQuote';


// import OrderStatusPills from './other/OrderStatusPills';
// import { RESTRICTED_VENDORS, NO_UPDATE_QTY_PRODUCT_TYPES, ONLY_QTY_PRODUCT_TYPES } from '../../utils/constants';
// import DraftOrderHeader from './other/DraftOrderHeader';
import { formatDate, useFormatUSD } from '../../utils/formatting';
// import { PdfIcon } from '../../utils/icons';
// import { BsSend } from "react-icons/bs";
// import { FaRegFilePdf } from 'react-icons/fa6';



const MAX_THUMBS = 5;

/** Earliest pending ship date across the order's line items, or null. */
function nextShipDate(order) {
  const dates = (order.lineItems || [])
    .map((item) => item.estimatedShipDate)
    .filter(Boolean)
    .sort();
  return dates[0] ?? null;
}

function OrderCardExpandable({ order, index, filterBy }) {
  const navigate = useNavigate();
  const cardRef = useRef(null);

  const goToDetail = () => navigate(`/order/${order.id}`);

  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedAttributes, setExpandedAttributes] = useState(new Set());

  const [modalContent, setModalContent] = useState(null);
  // const [lineItemsExpanded, setLineItemsExpanded] = useState(false);

  // Calculate expiration status
  // const { expired, expirationColorClass, expirationText, expirationTextClass } = useExpirationStatus(order.expirationDate);

  // const order = order.order;
  // if (!order) return null;
  // const isOrder = order?.id;
  // const createdAt = isOrder ? order.createdAt : order.createdAt;
  // const total = isOrder ? order.totalPrice : order.totalPrice;
  // const showExpired = !isOrder && expired;

  // Expand the first visible quote whenever the list (index) or filter changes
  useEffect(() => {
    setIsExpanded(index === 0);
  }, [index, filterBy]);

  const shipDate = nextShipDate(order);



  // const showModal = (content) => {
  //   setModalContent(content);
  // };

  const closeModal = () => {
    setModalContent(null);
  };

  // const { handleApprove, handleDecline, handleRequestUpdates, handleRequestExtension, handleAskQuestion } = useDraftOrderActionModals({
  //   showModal,
  //   orderId: order.id,
  //   onComplete: removeCard,
  //   quoteName: order?.name || order?.order?.name,
  //   // canPayByPo: customerCanPayByPo(order?.customer?.tags),
  //   customerEmail: order?.customer?.email,
  // });

  const handleViewDetails = () => {
    order.id
      ? navigate(`/order/${order.id}`)
      : navigate(`/draft-order/${order.id}`);
  };

  // const handleToggleCollapsible = () => {
  //   setIsExpanded(prev => !prev);
  // };

  const toggleAttributesExpanded = (index) => {
    setExpandedAttributes(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };
  

  const sortedLineItems = useMemo(() => {
    const items = order.lineItems || [];
    return items
      .map((item, originalIdx) => ({ item, originalIdx }))
      .sort((a, b) => {
        // const aRestricted = RESTRICTED_VENDORS.includes(a.item.vendor);
        // const bRestricted = RESTRICTED_VENDORS.includes(b.item.vendor);
        // if (aRestricted && !bRestricted) return 1;
        // if (!aRestricted && bRestricted) return -1;

        // same restriction group → sort by title
        const titleA = (a.item.title || '').toLowerCase();
        const titleB = (b.item.title || '').toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
      });
  }, [order.lineItems]);

  const isCancelledOrder = !!order.cancelledAt;
  const showQuoteNumber = !isCancelledOrder && !!order.draft;
  const clickableProps = handleViewDetails ? { onClick: handleViewDetails } : {};

  return (
    <div 
      ref={cardRef}
      className={`draft-order card card-expandable ${order.cancelledAt ? 'order-cancelled' : ''}`}
      style={{ animationDelay: `${index * 0.05}s` }}
    >

      {/* <OrderHeader order={order} onClick={goToDetail} /> */}

      <button
        className="card__collapsible-button"
        data-action="toggle-collapsible"
        aria-expanded={isExpanded}
        aria-controls={`order-${order.id}`}
        data-close-siblings="false"
        // onClick={handleToggleCollapsible}
      >
        <span className="card__title expandable-title" {...(!isCancelledOrder ? clickableProps : {})}>
          <div className="draft-order-title">
            <span className="order-name heading h3" >
              Order {order.name}
              {showQuoteNumber && <span className="quote-number">&nbsp;-&nbsp;(Quote {order.draft})</span>}
            </span>
          </div>
          

          <OrderStatusPills
            order={order}
            className="draft-order-status-expandable"
          />
        </span>

        
        <div className="total-amount-header">
          <span>Total: <strong className="total-amount-value">{useFormatUSD(order.totalPrice)}</strong></span>

          <div className="draft-order-meta">
            {order.createdAt && (
              <div className="created-on">
                Order Created: <span className="date-value">{formatDate(order.createdAt)}</span>
              </div>
            )}
          </div>

          <div className="items-count">({order.lineItems.length} Item{order.lineItems.length > 1 ? 's' : ''})</div>
        </div> 
        

        <span className="plus-button plus-button--large"></span>
      </button>


      <div className={`card__collapsible ${isExpanded ? 'expanded' : ''}`} id={`order-${order.id}`}>

        <div className="line-items">
          {sortedLineItems.map(({ item, originalIdx }) => (
            <LineItem
              key={originalIdx}
              item={item}
              index={originalIdx}
              variant="card"
              isOrder
              expandThreshold={3}
              isExpanded={expandedAttributes.has(originalIdx)}
              onToggleExpand={toggleAttributesExpanded}
              showManual={true}
              
            />
          ))}
        </div>


        <div className="order-summary-expandable">

          <div className="summary-row total">
            <span className="summary-label">Total</span>
            <strong className="total-amount-value">{useFormatUSD(order.totalPrice)}</strong>
          </div>



          {!order.cancelledAt && (
            <div className="order-actions order-actions-expandable">


              <button type="button" className="button button--primary button--bordered" onClick={goToDetail}>
                View Order
              </button>

              {/* {order.statusPageUrl && (
                <a
                  className="button button--secondary button--bordered"
                  href={order.statusPageUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Track Shipment
                </a>
              )} */}
            </div>
          )}

          {/* <div className="testing2">
            <pre>{JSON.stringify(order, undefined, 2)}</pre>
          </div> */}
          
          
        </div>

      </div>
    </div>
  );
}

export default OrderCardExpandable;
